// extracted by mini-css-extract-plugin
export default {"order":"order-details_order__InRav","infoMessage":"order-details_infoMessage__zkYrz"};